
import React from "react";
import { useNavigate } from "react-router-dom";

interface FooterLinkItem {
  label: string;
  path: string;
}

interface FooterLinkSectionProps {
  title: string;
  links: FooterLinkItem[];
}

export const FooterLinkSection = ({ title, links }: FooterLinkSectionProps) => {
  const navigate = useNavigate();

  return (
    <div>
      <h4 className="font-playfair text-lg font-medium mb-4 text-yarn-slate">{title}</h4>
      <ul className="space-y-3">
        {links.map((link) => (
          <li key={link.path}>
            <button
              className="text-yarn-slate hover:text-primary transition-colors flex items-center gap-1.5 group"
              onClick={() => navigate(link.path)}
            >
              <span className="w-0 h-0.5 bg-primary scale-x-0 origin-left transition-all duration-300 group-hover:w-3 group-hover:scale-x-100"></span>
              <span>{link.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
